import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, Card, Collapse, SxProps, Typography } from '@mui/material';
import { useStore } from '@priolo/jon';
import React, { HTMLAttributes, ReactNode, useEffect, useRef } from 'react';
import deviceSo from 'stores/layout/device';



interface Props extends HTMLAttributes<HTMLElement> {
	icon?: React.ReactNode
	title?: any
	titleVar?: any
	endRender?: React.ReactNode
	compact?: boolean
	collapsed?: boolean
	selectable?: boolean

	onCollapsedChange?: (collapsed: boolean) => void
	onTitleClick?: (e: React.MouseEvent) => void
	onTitleVisibleChange?: (visible: boolean) => void

	children?: ReactNode
	sx?: SxProps
	id?: any
}

const FormParagraph = React.forwardRef<HTMLElement, Props>(({
	id,
	icon,
	title,
	titleVar = "h6",
	endRender,
	compact,
	collapsed,
	selectable,

	onCollapsedChange,
	onTitleClick,
	onTitleVisibleChange,

	children,
	sx,
	...props
}, ref) => {

	// STATE
	useStore(deviceSo)


	// HOOKs
	const titleRef = useRef<HTMLElement>(null)

	useEffect(() => {
		if (!id || !selectable) return
		// const observer = new IntersectionObserver(
		// 	([entry]) => {
		// 		if (!entry.isIntersecting && deviceSo.state.linkIdSelect == id) {
		// 			deviceSo.setLinkIdSelect(null)
		// 		}
		// 	},
		// 	{ root: null, threshold: 0 }
		// )
		// if (titleRef.current) observer.observe(titleRef.current)

		// controllo se c'e' un elemento selezionato allo ra scrollo
		if (deviceSo.state.linkIdSelect == id) {
			const elm = document.getElementById(id)
			elm?.scrollIntoView({ behavior: "smooth", block: "center" })
		}
		// return () => {
		// 	if (titleRef.current) observer.unobserve(titleRef.current)
		// }
	}, [])

	// HANDLER
	const handleIconClick = (e: React.MouseEvent) => {
		e.stopPropagation()
		onCollapsedChange?.(!collapsed)
	}
	const handleTitleClick = (e) => {
		if (selectable && deviceSo.state.linkIdSelect != id) deviceSo.setLinkIdSelect(id)
		if (!onTitleClick) {
			onCollapsedChange?.(!collapsed)
			return
		}
		if (collapsed) onCollapsedChange?.(false)
		onTitleClick?.(e)
	}

	// RENDER
	const isCollapsable = !!onCollapsedChange
	if (isCollapsable) icon = collapsed ? <KeyboardArrowUp /> : <KeyboardArrowDown />
	const mh = compact ? "5px" : "15px"
	const styTitle: SxProps = {
		display: "flex",
		alignItems: "center",
		cursor: isCollapsable || !!props.onClick || !!onTitleClick ? "pointer" : "default",
		mb: isCollapsable ? 0 : mh
	}
	const sxSelected: SxProps = selectable && deviceSo.state.linkIdSelect == id ? sxSelect : null

	return <Card
		ref={ref as any}
		sx={{ ...sxCard, ...sxSelected, ...sx } as SxProps}
		id={id}
		{...props}
	>

		{/* TITLE */}
		{title && <Box
			sx={styTitle}
			onClick={handleTitleClick}
			ref={titleRef}
		>

			{icon && <Box
				sx={{ display: "flex", mr: "5px", mt: "-3px" }}
				onClick={handleIconClick}
			>{icon}</Box>}

			<Typography variant={titleVar}>
				{title}
			</Typography>

			<Box sx={{ flex: 1 }} />

			{endRender}

		</Box>}

		{!isCollapsable ? children :
			<Collapse in={!collapsed} timeout="auto">
				<Box sx={{ mb: mh }} />
				{children}
			</Collapse>
		}
	</Card>
})

FormParagraph.displayName = "FormParagraph"

export default FormParagraph

const sxCard: SxProps = {
	position: "relative",
	overflow: "visible",
	display: "flex",
	flexDirection: "column",
	padding: "16px 20px 16px 20px",
	borderRadius: "10px",
}

const sxSelect: SxProps = {
	//outline: "3px solid rgba(255,255,255,.2)",
	outline: `1px solid #ffffff5b`,
}